import { ReadContractorVisit } from "@/types/contractorVisit";
import { DateTime } from "luxon";
import { useMemo } from "react";

const FIXED_TIME = "00:00";

export const useContractorVisitDateTimeDefaultValues = (
  visit?: ReadContractorVisit,
) => {
  return useMemo(() => {
    const startDateTime = visit?.start_datetime
      ? DateTime.fromISO(visit.start_datetime)
      : null;
    const endDateTime = visit?.end_datetime
      ? DateTime.fromISO(visit.end_datetime)
      : null;

    if (startDateTime?.isValid && endDateTime?.isValid) {
      return {
        start_datetime: startDateTime.toISO() ?? "",
        end_datetime: endDateTime.toISO() ?? "",
      };
    }

    const date = DateTime.fromISO(visit?.date ?? "");
    if (!date.isValid) {
      return { start_datetime: "", end_datetime: "" };
    }

    const [hour, minute] = FIXED_TIME.split(":").map(Number);

    const fallbackStart = DateTime.fromObject({
      year: date.year,
      month: date.month,
      day: date.day,
      hour,
      minute,
    });

    const fallbackEnd = DateTime.fromObject({
      year: date.year,
      month: date.month,
      day: date.day,
      hour,
      minute,
    });

    return {
      start_datetime: fallbackStart.toISO() ?? "",
      end_datetime: fallbackEnd.toISO() ?? "",
    };
  }, [visit]);
};
